// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__AB0O8","show":"modal_show__qSmOh","hide":"modal_hide__G+UbR","modal_body":"modal_modal_body__UmJ7C","close":"modal_close__Sp4z4"};